import {DefaultPinProperties, GroupPinProperties} from "../constants";

export const getMarkersData = (id) => {
	const elements = Array.from(document.querySelectorAll(`.map-marker[data-for="${id}"][data-latitude][data-latitude], .grouped-map-marker[data-for="${id}"][data-latitude][data-latitude]`));

	return elements.map((data, i) => ({
		id: data.getAttribute(`data-complex`),
		latitude: data.getAttribute(`data-latitude`),
		longitude: data.getAttribute(`data-longitude`),
		icon: data.getAttribute(`data-icon`) || DefaultPinProperties.PATH,
		iconWidth: data.hasAttribute(`data-group`) ? GroupPinProperties.WIDTH : DefaultPinProperties.WIDTH,
		iconHeight: data.hasAttribute(`data-group`) ? GroupPinProperties.HEIGHT : DefaultPinProperties.HEIGHT,
		get iconAnchorX ()
		{
			return this.iconWidth / 2 * -1;
		},
		get iconAnchorY ()
		{
			return this.iconHeight * -1;
		},
		markup: data.getAttribute(`data-markup`),
		group: data.getAttribute(`data-group`),
	}));
};
